export default "__VITE_ASSET__DMnp9Mdg__"